import { render, staticRenderFns } from "./AppMarketplace.vue?vue&type=template&id=0a071961&scoped=true&"
import script from "./AppMarketplace.vue?vue&type=script&lang=js&"
export * from "./AppMarketplace.vue?vue&type=script&lang=js&"
import style0 from "./AppMarketplace.vue?vue&type=style&index=0&id=0a071961&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a071961",
  null
  
)

export default component.exports